import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/layout/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";

// Public pages
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";

// App pages
import DashboardPage from "@/pages/app/DashboardPage";
import TravelRequestsPage from "@/pages/app/TravelRequestsPage";
import NewTravelRequestPage from "@/pages/app/NewTravelRequestPage";
import TravelRequestDetailPage from "@/pages/app/TravelRequestDetailPage";
import ExpenseClaimsPage from "@/pages/app/ExpenseClaimsPage";
import NewExpenseClaimPage from "@/pages/app/NewExpenseClaimPage";
import ExpenseClaimDetailPage from "@/pages/app/ExpenseClaimDetailPage";
import CashAdvancesPage from "@/pages/app/CashAdvancesPage";
import ReportsPage from "@/pages/app/ReportsPage";
import PoliciesPage from "@/pages/app/PoliciesPage";
import VendorsPage from "@/pages/app/VendorsPage";
import NotificationsPage from "@/pages/app/NotificationsPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          {/* Public */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/landing" element={<LandingPage />} />

          {/* Protected App */}
          <Route path="/app" element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />

            {/* Travel Requests */}
            <Route path="travel-requests" element={<TravelRequestsPage />} />
            <Route path="travel-requests/new" element={
              <ProtectedRoute roles={['employee', 'admin']}>
                <NewTravelRequestPage />
              </ProtectedRoute>
            } />
            <Route path="travel-requests/:id" element={<TravelRequestDetailPage />} />

            {/* Expense Claims */}
            <Route path="expense-claims" element={<ExpenseClaimsPage />} />
            <Route path="expense-claims/new" element={
              <ProtectedRoute roles={['employee', 'admin']}>
                <NewExpenseClaimPage />
              </ProtectedRoute>
            } />
            <Route path="expense-claims/:id" element={<ExpenseClaimDetailPage />} />

            {/* Cash Advances */}
            <Route path="cash-advances" element={<CashAdvancesPage />} />

            {/* Reports */}
            <Route path="reports" element={
              <ProtectedRoute roles={['manager', 'finance', 'admin']}>
                <ReportsPage />
              </ProtectedRoute>
            } />

            {/* Admin: Policies */}
            <Route path="policies" element={
              <ProtectedRoute roles={['admin']}>
                <PoliciesPage />
              </ProtectedRoute>
            } />

            {/* Travel Desk: Vendors */}
            <Route path="vendors" element={
              <ProtectedRoute roles={['travel_desk', 'admin']}>
                <VendorsPage />
              </ProtectedRoute>
            } />

            {/* Notifications */}
            <Route path="notifications" element={<NotificationsPage />} />

            {/* Team */}
            <Route path="team" element={<DashboardPage />} />
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
